import {RestService} from "@/services/rest/RestService";
import {AdminAuthenticationEndpointsApi} from "@/api/pharma-auth-admin/apis/admin-authentication-endpoints-api";
import {TokenExchangeRequestRestDto, TokenExchangeResponseRestDto} from "@/api/pharma-auth-admin/models";

export class TokenExchangeRestService extends RestService {

    private apiService: AdminAuthenticationEndpointsApi;

    protected constructor() {
        super();

        this.apiService = new AdminAuthenticationEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getApiGwUrl('pharma-auth'));
    }

    public async exchangeToken(request: TokenExchangeRequestRestDto): Promise<TokenExchangeResponseRestDto> {
        const response = await this.apiService.exchangeToken(request);

        return response.data;
    }
}
